export default __webpack_public_path__ + "static/media/35t.b39ab9d1.jpg";